// extracted by mini-css-extract-plugin
export default {"modal":"DurationWarningModal_modal__P6P55"};